import { Plus, SlidersHorizontal } from 'lucide-react';
import { PALETTE, NODE_GROUPS, iconForKey, type NodeGroup } from './nodeTypes';
import type { WorkflowNodeKind } from './types';

interface NodePaletteProps {
  onAdd: (kind: WorkflowNodeKind) => void;
}

// Draggable palette. Each swatch is HTML5-draggable: dropping onto the canvas
// (FlowCanvas onDrop) reads the kind back and adds a node at the cursor. The
// click handler is the no-drag fallback (drops at canvas centre).
export function NodePalette({ onAdd }: NodePaletteProps) {
  const onDragStart = (e: React.DragEvent<HTMLButtonElement>, kind: WorkflowNodeKind) => {
    e.dataTransfer.setData('application/reactflow', kind);
    e.dataTransfer.effectAllowed = 'move';
  };

  return (
    <div className="bg-white border border-[#EDEDEB] rounded-2xl p-4.5 space-y-3.5 shadow-2xs">
      <div>
        <h4 className="text-xs font-bold text-slate-800 uppercase tracking-wider flex items-center gap-2">
          <SlidersHorizontal className="w-4 h-4 text-purple-600" />
          Node Palette
        </h4>
        <p className="text-[10px] text-slate-500 mt-0.5">Drag a node onto the canvas, or click to add:</p>
      </div>

      {NODE_GROUPS.map((group: NodeGroup) => (
        <div key={group} className="space-y-1.5">
          <span className="text-[9px] font-mono font-bold text-slate-400 uppercase tracking-wider">{group}</span>
          <div className="grid grid-cols-2 gap-2">
            {PALETTE.filter((p) => p.group === group).map((p) => {
              const Icon = iconForKey(p.iconKey);
              return (
                <button
                  key={p.kind}
                  draggable
                  onDragStart={(e) => onDragStart(e, p.kind)}
                  onClick={() => onAdd(p.kind)}
                  title={p.description}
                  className={`flex items-center gap-1.5 px-2 py-2 rounded-lg border ${p.swatch} text-[10px] font-bold text-left transition cursor-grab active:cursor-grabbing`}
                >
                  <Icon className="w-3.5 h-3.5 shrink-0" />
                  <span className="truncate">{p.label}</span>
                  <Plus className="w-3 h-3 ml-auto shrink-0 opacity-60" />
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
